<template>
    <div id="newReason">
        <div class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form" @submit.prevent="saveReason">
                        <div class="form-group row">
                            <div class="col-sm-2" >
                                <label class="control-label" for="url_short_name">{{ label.reason_id }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="url_short_name" name="url_short_name" v-model="reason.URL_short_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="display_name">{{ label.reason_name }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="display_name" name="display_name" v-model="reason.display_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="created_at">{{ label.created_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="created_at" name="new_created_at" v-model="reason.created_at" >
                            </div>
                            <div class="col-sm-2">
                                <label class="control-label" for="ended_at">{{ label.ended_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="ended_at" name="ended_at" v-model="reason.ended_at" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="is_enabled">{{ label.is_enabled }}</label>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="enabled_yes" value="0" v-model="reason.is_enabled">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.enabled_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="enabled_no" value="1" v-model="reason.is_enabled">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.enabled_no }}</label>
                                </div>
                            </div>   
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="remark">{{ label.remark }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="remark" name="remark" v-model="reason.remark" >
                            </div>
                        </div>
                        <div class="form-group row text-center">
                            <div class="col-sm-11">                        
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/reason`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
          title: 'NEW REASON',
          label: {
                reason_id: 'REASON ID',
                reason_name: 'REASON NAME',
                created_at: 'EFFECTIVE FROM',
                ended_at: 'EFFECTIVE UNTIL',
                is_enabled: 'DISABLED',
                enabled_yes: 'YES',
                enabled_no: 'NO',
                remark: 'REMARK'
            },
            reason: {
                URL_short_name: null,
                display_name: null,
                created_at: null,
                ended_at: null,
                is_enabled: 0,
                remark: null
            },
            validationMsg: '',
            status: '',
        
        }
    },

    methods: {
        saveReason() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/reason'

            axios.post(this.$store.getters.rootAPI + '/clock/reason/create', {
                URL_short_name: vm.reason.URL_short_name,
                display_name: vm.reason.display_name,
                created_at: vm.reason.created_at,
                ended_at: vm.reason.ended_at,
                is_enabled: vm.reason.is_enabled,
                remark: vm.reason.remark
            })
            .then(function (response) {  
                vm.status = response.data.status
                
                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }              
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/reason/NewReason.vue